import { useLocation } from 'wouter'

import { DropdownMenu } from '@/components/DropdownMenu'
import { Card } from '@/components/Card'
import { AvatarGroup } from '@/components/AvatarGroup'
import { More } from '@/components/More'
import { Button } from '@/components/Button'
import { useTeamMembers } from '@/hooks/useTeamMembers'
import { Team } from '@/types'

import s from './TeamItem.module.css'

type Props = {
  team: Team
  onAddMember: () => void
  onDelete: (teamId: string) => void
}

export const TeamItem = ({ team, onAddMember, onDelete }: Props) => {
  const { data: members } = useTeamMembers(team.id)
  const [, setLocation] = useLocation()

  return (
    <Card>
      <div
        className={s.content}
        onClick={() => {
          localStorage.setItem('teamName', team.name)
          setLocation(`/${team.id}/members`)
        }}
      >
        <div className={s.title}>{team.name}</div>

        <div className={s.actions}>
          <div>{members?.length ? <AvatarGroup users={members} /> : null}</div>
          <Button
            variant="secondary"
            onClick={(e) => {
              e.stopPropagation()
              onAddMember()
            }}
          >
            Add Members
          </Button>
          <DropdownMenu>
            <DropdownMenu.Trigger>
              <More />
            </DropdownMenu.Trigger>
            <DropdownMenu.Content>
              <DropdownMenu.Item onClick={() => onDelete(team.id)} destructive>
                Delete
              </DropdownMenu.Item>
            </DropdownMenu.Content>
          </DropdownMenu>
        </div>
      </div>
    </Card>
  )
}
